<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title>
      <b class="disable_ripple_font"> ADULT EDUCATION (CURRENTLY ENROLLED IN GRADES NA, AD)</b>
	  <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_AdultEducation_Overview'"></help-text-btn>
    </mat-panel-title>
    <mat-panel-description>

      <mat-icon></mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <form [formGroup]="frmOsy">
    <!-- Current Parent/Guardian 1  Relationship  Phone 1-->
    <div class="row">
      <div class="col-4">
        <mat-label><b>Dropped out? </b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_AdultEducation_DroppedOut'"></help-text-btn>
      </mat-label>
        <mat-radio-group aria-label name="radioDroppedout" formControlName="radioDroppedout" id="radioDroppedout">
          <div class="row">
            <div class="col">
              <div class="row">
                <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
              </div>
              <div class="row">
                <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
              </div>
            </div>
          </div>
        </mat-radio-group>
      </div>
      <div class="col-4">
        <mat-label><b>Enrolled in</b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_AdultEducation_EnrolledIn'"></help-text-btn>
		</mat-label>
        <div class="row">
          <div class="col">
            <div class="row">
              <mat-checkbox [color]="'primary'" formControlName="adultEducation">Adult Education</mat-checkbox>
            </div>
            <div class="row">
              <mat-checkbox [color]="'primary'" formControlName="GED">GED</mat-checkbox>
            </div>
            <div class="row">
              <mat-checkbox [color]="'primary'" formControlName="HEP">HEP</mat-checkbox>
            </div>
            <div class="row">
              <mat-checkbox [color]="'primary'" formControlName="Other">Other</mat-checkbox>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>Comments</mat-label>
                  <input matInput type="text" formControlName="otherComments"
                    (focusout)="updateChangeValueLostFocus()" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <mat-form-field appearance="outline">
          <mat-label><b>Comments</b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_AdultEducation_Comments'"></help-text-btn>
          </mat-label>
          <textarea matInput rows="7" cols="50" type="string" formControlName="adultEducationComments"
            (focusout)="updateChangeValueLostFocus()"></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>


  <div class="row" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-expansion-panel>